import ATS from "./ATS.svg";
import AccountDetail from "./AccountDetail.svg";
import Applicant from "./Applicant.svg";
import Asset from "./Asset.svg";
import Attendence from "./Attendence.svg";
import Billing from "./Billing.svg";
import Board from "./Board.svg";
import Client from "./Client.svg";
import ClientWiseOrg from "./ClientWiseOrg.svg";
import CreateApplicant from "./CreateApplicant.svg";
import CreateClient from "./CreateClient.svg";
import CreateJob from "./CreateJob.svg";
import CreatePlacement from "./CreatePlacement.svg";
import CreateProjectOrg from "./CreateProjectOrg.svg";
import CreateSubVendor from "./CreateSubVendor.svg";
import CreateVendor from "./CreateVendor.svg";
import Detail from "./Detail.svg";
import Employment from "./Employment.svg";
import Finance from "./Finance.svg";
import HolidayCalendar from "./HolidayCalendar.png";
import Home from "./Home.svg";
import InterviewSchedule from "./InterviewSchedule.svg";
import Invoice from "./Invoice.svg";
import JobPosting from "./JobPosting.svg";
import JobWise from "./JobWise.svg";
import MyOrganzation from "./MyOrganzation.png";
import MyTime from "./MyTime.svg";
import PastPayrun from "./PastPayrun.svg";
import PaySlips from "./PaySlips.svg";
import Profile from "./Profile.svg";
import Project from "./Project.svg";
import Prospect from "./Prospect.svg";
import RecruiterWise from "./RecruiterWise.svg";
import RunPayroll from "./RunPayroll.svg";
import SignOut from "./SignOut.svg";
import TEAM from "./TEAM.svg";
import TaxForm from "./TaxForm.svg";
import ViewApplicant from "./ViewApplicant.svg";
import ViewClient from "./ViewClient.svg";
import ViewEmployee from "./ViewEmployee.svg";
import ViewJob from "./ViewJob.svg";
import ViewPayroll from "./ViewPayroll.svg";
import ViewPlacement from "./ViewPlacement.svg";
import ViewProject from "./ViewProject.svg";
import ViewSchedule from "./ViewSchedule.svg";
import ViewSubVendor from "./ViewSubVendor.svg";
import ViewVendor from "./ViewVendor.svg";
import CreateNotification from "./bell-icon.svg";
import createuser from "./create user.svg";
import createorganization from "./create-organization.svg";
import Hierarchy from "./hierarchy.svg";
import OfferLetter from "./offer-letter.svg";
import organization from "./organization.svg";
import Policy from "./policy.svg";
import Template from "./template.svg";
import ViewOffer from "./view-offer.svg";
import vieworganization from "./view-organization.svg";
import viewuser from "./viewuser.svg";
import WorkFlow from "./workflow.svg";
import Casual from "./Casual.svg";
import Medical from "./Medical.svg";
import Dollar from "./Dollar.svg";
import MaleUser from "./MaleUser.svg";
import FemaleUser from "./FemaleUser.svg";
import Budget from "./budget.svg";
import Preonboarding from "./preonboarding.png";
import Survey from "./survey.png";
import Gratuity from "./gratuity.png";
import Settlement from "./f&f.png";
import Uploaddocument from "./documentupload.png";
import Applicantlogin from "./applicantlogin.png";
import Email from "./Email.svg";
import Approval from "./Approval.svg";
import Apperciatation from "./Apperciataion.svg";
import Appraisal from "../svg/Apprisal.svg";
import TimeSheet from "../svg/Timesheet.svg";
import ViewPerformance from "../svg/ViewPerformance.svg";
import Tools from "../svg/Tools.svg";
import Survey1 from "../svg/Survey.svg";
import email from "../svg/email2.svg";
import Deprtment from "../svg/DepandRole.svg";
import Screens from "../svg/Screens.svg";
import Leave from "../svg/Leave.svg";
import Workflw from "../svg/Workflw.svg";
import Office from "../svg/Office.svg";
import Viewoffice from "../svg/Viewoffice.svg";
import payroll2 from "../svg/payroll2.svg";
import viewpayroll2 from "../svg/viewpayroll2.svg";
import Hirerarchy from "../svg/Hirerarchy.svg";
import Task from "../svg/Task.svg";
import Timeline from "../svg/Timeline.svg";
import Approval2 from "../svg/Approval2.svg";
import Happroval from "../svg/happroval.svg";
import AuthSignature from "../svg/AuthSignature.svg";
import Financial from "../svg/Financial.svg";
const Svgs = {
  Apperciatation,
  Asset,
  Approval,
  Email,
  ATS,
  Board,
  Budget,
  CreateClient,
  CreateJob,
  JobPosting,
  Applicant,
  Client,
  CreatePlacement,
  Detail,
  Employment,
  AccountDetail,
  Finance,
  Home,
  InterviewSchedule,
  Invoice,
  JobWise,
  PastPayrun,
  PaySlips,
  Profile,
  ViewApplicant,
  ViewClient,
  ViewEmployee,
  ViewJob,
  ViewPayroll,
  ViewSchedule,
  ViewVendor,
  Prospect,
  CreateVendor,
  Project,
  RecruiterWise,
  SignOut,
  RunPayroll,
  TaxForm,
  ViewPlacement,
  CreateApplicant,
  Attendence,
  organization,
  createorganization,
  vieworganization,
  createuser,
  viewuser,
  CreateProjectOrg,
  ClientWiseOrg,
  ViewProject,
  TEAM,
  ViewSubVendor,
  CreateSubVendor,
  Billing,
  CreateNotification,
  MyTime,
  HolidayCalendar,
  MyOrganzation,
  Hierarchy,
  Template,
  Policy,
  WorkFlow,
  OfferLetter,
  ViewOffer,
  Casual,
  Medical,
  Dollar,
  MaleUser,
  FemaleUser,
  Preonboarding,
  Survey,
  Gratuity,
  Settlement,
  Uploaddocument,
  Applicantlogin,
  Appraisal,
  TimeSheet,
  ViewPerformance,
  Tools,
  Survey1,
  email,
  Deprtment,
  Screens,
  Leave,
  Workflw,
  Office,
  Viewoffice,
  payroll2,
  viewpayroll2,
  Hirerarchy,
  Task,
  Timeline,
  Approval2,
  Happroval,
  AuthSignature,
  Financial,
};

export default Svgs;
